import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=5ca06455&"
import script from "./Search.vue?vue&type=script&lang=js&"
export * from "./Search.vue?vue&type=script&lang=js&"
import style0 from "./Search.vue?vue&type=style&index=0&id=5ca06455&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ca06455')) {
      api.createRecord('5ca06455', component.options)
    } else {
      api.reload('5ca06455', component.options)
    }
    module.hot.accept("./Search.vue?vue&type=template&id=5ca06455&", function () {
      api.rerender('5ca06455', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Search/Search.vue"
export default component.exports